import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SubmitResponse } from '../../models';
import { HttpService } from './http.service';

export interface SocialMediaContactInput {
  name: string;
  email: string;
  phone: string;
  message: string;
}

@Injectable({
  providedIn: 'root',
})
export class SocialMediaContactService extends HttpService<SocialMediaContactInput, never> {
  constructor(
    httpClient: HttpClient,
    @Inject('API_URL') apiUrl: string,
    @Inject('API_VERSION') apiVersion: string
  ) {
    super(httpClient, apiUrl, apiVersion, 'social-media-contact');
  }

  submitContact(payload: SocialMediaContactInput): Observable<SubmitResponse> {
    return this.create(payload);
  }
}
